<h1 mat-dialog-title class="aza-pa-dialog-title" translate>DEPENDENCIES</h1>

<div mat-dialog-content class="table-container aza-pa-dialog-content">
  @if (advancedSearchData) {
    <azavista-table
      [columns]="columns" [displayedColumns]="displayedColumns" [dataSource]="dataSource"
      [actions]="actions" [pagingOptions]="pagingOptions"
      [showAdvancedSearch]="true"
      [showAdvancedSearchQuickSearch]="true"
      [showAdvancedSearchFilters]="true"
      [advancedSearchAllFields]="advancedSearchData.allFields"
      [advancedSearchFilters]="advancedSearchData.advancedFilters"
      [selection]="selection"
      (rowActionSelected)="onRowActionSelected($event)"
      (advancedSearchChanged)="searchDependencies($event)"
      (rowClicked)="processViewOrEditAction($event.id)" (pagingChanged)="searchDependencies($event)">
    </azavista-table>
  }
</div>

<div mat-dialog-actions class="aza-pa-action-buttons">
  <azavista-flat-button action="add_dependency" (click)="onAddNew()" color="primary" class="aza-pa-action-button-apply-buton">+ <span translate
  class="uppercased">ADD_DEPENDENCY</span></azavista-flat-button>
  <azavista-flat-button action="close" (click)="onClose()" color="primary" class="add-new-dependency-button-close-button"><span translate
  class="uppercased">CLOSE</span></azavista-flat-button>
</div>
